<template>
  <div class="date-picker">
    <date-picker
      :value="value"
      type="date"
      :format="getLocalizedFormat()"
      value-type="YYYY-MM-DD"
      :lang="locale"
      :clearable="clearable"
      :disabled-date="disabledAfterToday"
      :placeholder="placeholder"
      @change="onChangeDate"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'DD MMMM YYYY',
    },
    disabledAfterToday: {
      type: Function,
      default: () => false,
    },
    disableBeforeToday: {
      type: Function,
      default: () => false,
    },
  },
  data() {
    return {
      km: {
        formatLocale: {
          months: [
            'មករា',
            'កុម្ភៈ',
            'មីនា',
            'មេសា',
            'ឧសភា',
            'មិថុនា',
            'កក្កដា',
            'សីហា',
            'កញ្ញា',
            'តុលា',
            'វិច្ឆិកា',
            'ធ្នូ',
          ],
          monthsShort: [
            'មករា',
            'កុម្ភៈ',
            'មីនា',
            'មេសា',
            'ឧសភា',
            'មិថុនា',
            'កក្កដា',
            'សីហា',
            'កញ្ញា',
            'តុលា',
            'វិច្ឆិកា',
            'ធ្នូ',
          ],
          weekdays: [
            'អាទិត្យ',
            'ច័ន្ទ',
            'អង្គារ',
            'ពុធ',
            'ព្រហស្បតិ៍',
            'សុក្រ',
            'សៅរ៍',
          ],
          weekdaysShort: ['អា', 'ច', 'អ', 'ពុ', 'ព្រ', 'សុ', 'សៅ'],
          weekdaysMin: ['អា', 'ច', 'អ', 'ពុ', 'ព្រ', 'សុ', 'សៅ'],
          firstDayOfWeek: 0,
          firstWeekContainsDate: 1,
        },
      },
      zh: {
        formatLocale: {
          months: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          monthsShort: [
            '一月',
            '二月',
            '行进',
            '四月',
            '可能',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          weekdays: [
            '星期日',
            '周一',
            '周二',
            '周三',
            '周四',
            '星期五',
            '周六',
          ],
          weekdaysShort: [
            "周日",
            "周一",
            "周二",
            "周三",
            "周四",
            "周五",
            "周六",
          ],
          weekdaysMin: [
            "周日",
            "周一",
            "周二",
            "周三",
            "周四",
            "周五",
            "周六",
          ],
          firstDayOfWeek: 0,
          firstWeekContainsDate: 1,
        },
        yearFormat: "YYYY年",
        monthFormat: "M月",
        monthBeforeYear: false,
      },
      vi: {
        formatLocale: {
          months: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          monthsShort: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          weekdays: [
            'Chủ nhật',
            'Thứ hai',
            'Thứ bà',
            'Thứ tư',
            'Thứ năm',
            'Thứ sáu',
            'Thứ bảy',
          ],
          weekdaysShort: ['CN', 'Th2', 'Th3', 'Th4', 'Th5', 'Th6', 'Th7'],
          weekdaysMin: ['CN', 'Th2', 'Th3', 'Th4', 'Th5', 'Th6', 'Th7'],
          firstDayOfWeek: 0,
          firstWeekContainsDate: 1,
        },
      },
    }
  },
  computed: {
    locale() {
      if (this.$i18n.locale == 'km') {
        return this.km
      } if (this.$i18n.locale == 'zh-cn') {
        return this.zh
      } if (this.$i18n.locale == 'vi') {
        return this.vi
      }
      return {}
    },
  },
  methods: {
    // disabledAfterToday(date) {
    //   const today = new Date()
    //   today.setHours(0, 0, 0, 0)

    //   if (this.disableBeforeToday && date < today) {
    //     return true
    //   }

    //   if (this.disableAfterToday && date > today) {
    //     return true
    //   }

    //   return false
    // },
    onChangeDate(date) {
      this.$emit('input', date)
    },
    getLocalizedFormat() {
      if (this.$i18n.locale === 'zh-cn') {
        return 'YYYY年 M月 D日'
      }
      return this.format
    },
  },
}
</script>
